import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sessione-roma-pqcifris',
  templateUrl: './sessione-roma-pqcifris.component.html',
  styleUrls: ['./sessione-roma-pqcifris.component.css']
})
export class SessioneRomaPqcifrisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
